import ShopifyClient from '../components/shopify-client';
import { getNumberId } from '../common/utils';

import Wishlist from '../common/wishlist';
const wishlist = Wishlist();

const initializeCustomersLogin = () => {
  const registerLink = document.querySelector('#fs-register-link');
  registerLink.href = registerLink.href + window.location.search;

  const visiblityButton = document.querySelector('#fs-visibility-button');
  visiblityButton.addEventListener('click', () => {
    if (visiblityButton.classList.contains('on')) {
      visiblityButton.querySelector('.on').classList.remove('show');
      visiblityButton.querySelector('.off').classList.add('show');
      visiblityButton.classList.remove('on');
      document.querySelector('#fs-password').type = 'password';
    } else {
      visiblityButton.querySelector('.on').classList.add('show');
      visiblityButton.querySelector('.off').classList.remove('show');
      visiblityButton.classList.add('on');
      document.querySelector('#fs-password').type = 'text';
    }
  });

  window.addEventListener('hashchange', handleHashChange);
  handleHashChange();

  showMembersOnly();
};

const handleHashChange = () => {
  if (location.hash == '#recover') {
    document.querySelector('#fs-login-section').classList.remove('show');
    document.querySelector('#fs-recover-section').classList.add('show');
  } else {
    document.querySelector('#fs-login-section').classList.add('show');
    document.querySelector('#fs-recover-section').classList.remove('show');
  }
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

const showMembersOnly = () => {
  if (!location.search || location.search.length <= 0) {
    return;
  }
  if (!location.search.includes('members_only=true')) {
    return;
  }
  const parts = location.search
    .replace('?', '')
    .split('&')
    .find((p) => p.includes('return_url='));
  if (!parts) {
    return;
  }
  const decoded = decodeURIComponent(parts.split('=')[1]);
  if (!decoded.startsWith('/products/')) {
    renderPageMembersOnly();
    return;
  }
  const queryRemoved = decoded.split('?')[0];
  const handle = queryRemoved.replace('/products/', '');
  const shopifyClient = new ShopifyClient('355c6398f60df7f6b05304372fb5fc6b');
  shopifyClient
    .fetchProductByHandle(handle)
    .then((product) => {
      wishlist.addShopifyProductToViewProducts(product);
      renderShopifyProduct(product);
    })
    .catch((err) => {
      /* console.error(err) */
    });
};

const renderPageMembersOnly = () => {
  const header = document.querySelector('#customers-login-2023-inner-header');
  header.classList.add('fs-hidden');
  const container = document.querySelector('#customers-login-2023-page-members-only');
  container.classList.add('show');
};

const renderShopifyProduct = (product) => {
  const productId = getNumberId(product.id);
  const variantId = getNumberId(product.variants.nodes[0].id);

  const image = product.images?.edges?.[0]?.node.url?.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'grande' + '.$2');
  let index = product.hover_image !== null ? parseInt(product.hover_image.value) : 2;
  if (!index || !product.images?.edges?.[index - 1]?.node) {
    index = 2;
  }
  let hoverImage = product.images?.edges?.[index - 1]?.node.url?.replace(
    /\/(.*)\.(\w{2,4})/g,
    '/$1_' + 'grande' + '.$2',
  );

  let compareAtPrice = !product.compareAtPriceRange
    ? null
    : parseInt(product.compareAtPriceRange.minVariantPrice.amount);
  const colors = !product.color ? [] : product.color.value.split(',').map((c) => c.split('|'));
  const salesTypes = !product.sales_type ? [] : product.sales_type.value.split(',');

  const card = renderProductCard(
    productId,
    variantId,
    product.handle,
    image,
    hoverImage,
    product.vendor,
    product.title,
    product.priceRange.minVariantPrice.amount,
    compareAtPrice,
    colors,
    salesTypes,
    product.tags,
    product.totalInventory,
  );

  const header = document.querySelector('#customers-login-2023-inner-header');
  header.classList.add('fs-hidden');

  const container = document.querySelector('#customers-login-2023-members-only');
  container.classList.add('show');

  const parent = container.querySelector('#customers-login-2023-product');
  parent.innerHTML = card;
};

const renderProductCard = (
  productId,
  variantId,
  handle,
  imageUrl,
  hoverImageUrl,
  vendor,
  title,
  price,
  compareAtPrice,
  colors,
  salesTypes,
  tags,
  inventory,
) => {
  const hoverImg = hoverImageUrl ? `<img class="fs-hover-image" src="${hoverImageUrl}" />` : '';

  let priceText = `<span class="fs-price">&yen; ${new Intl.NumberFormat('ja-JP').format(price)}</span>`;
  if (compareAtPrice && price != compareAtPrice) {
    let discountRate = ((1.0 - price / compareAtPrice) * 100.0).toString().split('.')[0];
    priceText += ` <span class="fs-original-price">&yen;${new Intl.NumberFormat('ja-JP').format(compareAtPrice)}</span>`;
    priceText += ` <span class="fs-discount-rate">(${discountRate}%OFF)</span>`;
  }

  let colorsText = '';
  if (colors && 0 < colors.length) {
    let colorDivs = colors
      .map((c) => {
        return `<div class="fs-color ${c[2] ? c[2] : ''}" style="background-color: ${c[1]}" title="${c[0]}"></div>`;
      })
      .join('');
    colorsText = `
      <div class="fs-colors">
        <div class="fs-color-title">全${colors.length}色</div>
        <div class="fs-colors-row">
          ${colorDivs}
        </div>
      </div>
    `;
  }

  let soldout = false;
  if (!tags.includes('coming soon') && !tags.includes('COMING SOON') && inventory == 0) {
    soldout = true;
  }

  return `
    <div class="fs-product" data-product-id="${productId}">
      <div class="fs-images">
        ${hoverImg}
        <img class="fs-image ${hoverImageUrl ? 'fs-has-hover' : ''}" src="${imageUrl}" />
      </div>
      <div class="fs-texts">
        <p class="fs-vendor">${vendor}</p>
        <p class="fs-name">${title}</p>
        ${colorsText}
        <div class="fs-row">
          <div class="fs-badges">
            ${salesTypes.includes('予約商品') ? '<div class="fs-badge presale">予約商品</div>' : ''}
            ${tags.includes('再入荷') ? '<div class="fs-badge restock">再入荷</div>' : ''}
            ${inventory == 1 ? '<div class="fs-badge stock">残り1点</div>' : ''}
            ${soldout ? '<div class="fs-badge soldout">SOLD OUT</div>' : ''}
            ${tags.includes('クーポン対象') ? '<div class="fs-badge sale">クーポン対象</div>' : ''}
            ${tags.includes('キャンペーン対象') ? '<div class="fs-badge sale">キャンペーン対象</div>' : ''}
            ${tags.includes('洗える') ? '<div class="fs-badge presale">洗える</div>' : ''}
            ${tags.includes('記事掲載') ? '<div class="fs-badge presale">記事掲載</div>' : ''}
            ${tags.includes('スナップ着用') ? '<div class="fs-badge presale">スナップ着用</div>' : ''}
            ${tags.includes('コラボアイテム') ? '<div class="fs-badge presale">コラボアイテム</div>' : ''}
            ${tags.includes('別注アイテム') ? '<div class="fs-badge presale">別注アイテム</div>' : ''}
          </div>
        </div>
      </div>
    </div>
  `;
};

/*
 * Main
 */

const customersLoginMain = () => {
  if (!location.pathname.startsWith('/account/login')) {
    return;
  }
  initializeCustomersLogin();
};

addEventListener('DOMContentLoaded', () => {
  customersLoginMain();
});
